import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TaskCalendar from "./taskCalender";
import TaskManager from "./taskManager";
import { useState } from "react";
import { useMaterialUIController } from "context";
import { useEffect } from "react";


const Attributes = {
  modes: [],
};

export default function TaskMaster({
  onLoad = () => {},
  pageId,
  searchText,
  registerCallBacks,
  pageName,
}) {
  const [value, setValue] = useState(0);
  const [updateList, setUpdateList] = useState(Date.now());
  const [controller] = useMaterialUIController();
  const { activePage } = controller;


   useEffect(() => {
      Attributes && onLoad(Attributes);
      registerCallBacks && registerCallBacks({});
    }, [activePage]);
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="Task Tabs"
        sx={{
          width: "50%", 
          display: "flex",
          justifyContent: "space-between",
          margin: "0 auto", 
          "& .MuiTab-root": {
            transition: "all 0.3s ease",
          },
          "& .Mui-selected": {
            backgroundColor: "info",
            height: "60px",
          },
        }}
      >
        <Tab label="Task Calendar" sx={{ width: "50%", height: "50px" }} />
        <Tab label="Task Details" sx={{ width: "50%", height: "50px" }} />
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {value === 0 && (
          <TaskCalendar updateList={updateList} setUpdateList={setUpdateList} />
        )}
        {value === 1 && (
          <TaskManager
            onLoad={onLoad}
            pageId={pageId}
            searchText={searchText}
            registerCallBacks={registerCallBacks}
            pageName={pageName}
            updateList={updateList}
            setUpdateList={setUpdateList}
          />
        )}
      </Box>
    </Box>
  );
}
